var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress-bar"},[_c('icon-circle',{staticClass:"icon base"}),_c('icon-circle',{ref:"icon",staticClass:"icon progress"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }